import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum CONFIRM_PASSWORD_FORM_FIELD {
	PASSWORD = 'password'
}

export enum CONFIRM_PASSWORD_FORM_FIELD_NAME {
	PASSWORD = 'Password'
}

export type ConfirmPasswordFieldType = {
	[CONFIRM_PASSWORD_FORM_FIELD.PASSWORD]: string,
}

export type ConfirmPasswordReturnFieldType = {
	password: string
}

export const getConfirmPasswordDetailSchema = (): Yup.SchemaOf<ConfirmPasswordFieldType> => Yup.object<Shape<ConfirmPasswordFieldType>>().shape ({
	[CONFIRM_PASSWORD_FORM_FIELD.PASSWORD]: Yup.string()
		.required('Password is required'),
});

export const initialConfirmPasswordValue = {
	[CONFIRM_PASSWORD_FORM_FIELD.PASSWORD]: ''
};

export const getFormattedConfirmPasswordFormField = (formikValues): ConfirmPasswordReturnFieldType => ({
	password: formikValues?.[CONFIRM_PASSWORD_FORM_FIELD.PASSWORD]
});


